import React from "react"
import { withRouter, RouteComponentProps } from "react-router-dom"
import { connect, ConnectedProps } from "react-redux"
import Link from "@mui/material/Link"
import { RootState, store } from "../../store/store"
import {
  driver,
  visit,
  facility,
  assetInfo,
  loadState
} from "../../store/actions/types"
import {
  setDriver,
  setVisit,
  setFacilityCode,
  setFacility,
  setLocation,
  setPath,
  setAssetInfo,
  enableAppBarResult
} from "../../store/actions"
import { Input } from "@fourkites/elemental-input"
import BottomBar from "../BottomBar/bottombar"
import AlertIcon from "components/AlertIcon/alertIcon"
import { http } from "utils/http"
import {
  isInvalidPhone,
  isInvalidName,
  isNumeric,
  isAlphaOrSpace
} from "utils/validation"
import { info } from "../../images"
import { toTitleCase } from "utils/string"
import { apiEndPoints } from "constants/apiEndpoints"
import "./driverForm.css"
import { getSiteCode } from "utils/common.util"
import { toast } from "react-toastify"
import { LocalStorage } from "storage"
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight"
import { withTranslation, Trans } from "react-i18next"
import setLoadDetails from "store/actions/loadDetailsAction"

const mapStateToProps = (state: RootState) => ({
  facility: state.facilityReducer.facility,
  location: state.locationReducer.location,
  path: state.locationReducer.path,
  facilityCode: state.locationReducer.facilityCode,
  asset: state.assetReducer.asset,
  enableAppBar: state.locationReducer.enableAppBar,
  details: state.loadDetailsReducer?.loadDetails
})

const mapDispatchToProps = {
  setDriver: (driver: driver) => setDriver(driver),
  setVisit: (visit: visit) => setVisit(visit),
  setLocation: (location: string) => setLocation(location),
  setPath: (path: string) => setPath(path),
  setFacilityCode: (facilityCode: string) => setFacilityCode(facilityCode),
  enableAppBarResult: (enableAppBar: boolean) =>
    enableAppBarResult(enableAppBar),
  setFacility: (facility: facility) => setFacility(facility),
  setAssetInfo: (asset: assetInfo) => setAssetInfo(asset),
  setLoadDetails: (details: loadState) => setLoadDetails(details)
}

const connector = connect(mapStateToProps, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>
type Props = PropsFromRedux & RouteComponentProps

interface State {
  phone: string
  disabledPhone: boolean
  invalidPhone: boolean
  name: string
  invalidName: boolean
  disabledProceed: boolean
  mode: any
  countryCode: string
  isLoading: boolean
  isGateLink: boolean
  LoadReferenceNumber: string
  disabledProceedforrefrence: boolean
}

class DriverForm extends React.Component<Props, State> {
  constructor(props: any) {
    super(props)
    this.state = {
      phone: "",
      isGateLink: false,
      disabledPhone: true,
      invalidPhone: false,
      name: "",
      invalidName: false,
      disabledProceed: true,
      mode: "",
      countryCode: "+1",
      isLoading: false,
      LoadReferenceNumber: "",
      disabledProceedforrefrence: false
    }
  }

  private getDriverPhone = () => {
    let urlParams: any = new URLSearchParams(window.location.search)
    let driverPhone: string = urlParams.get("dp") || ""
    return driverPhone?.replace(/\s/g, "") === ""
      ? ""
      : driverPhone.substring(driverPhone.length - 10)
  }
  getMode = () => {
    let urlParams: any = new URLSearchParams(window.location.search)
    let mode: string = urlParams.get("dp")
    if (mode === null) {
      return "kiosk"
    }
  }

  componentDidMount() {
    this.setState({
      mode: this.getMode()
    })
    let urlParams: any = new URLSearchParams(window.location.search)
    let mode: string = urlParams.get("dp")
    if (mode) {
      let countryCode = mode.substr(0, mode.length - 10)
      this.setState({
        countryCode: countryCode
      })
    }

    this.props.setPath("driverForm")
    this.props.setFacilityCode(getSiteCode())
    this.props.enableAppBarResult(true)
    http
      .get(`${apiEndPoints.facilities}?code=${getSiteCode()}`)
      .then(response => {
        const { data } = response.data
        const isGatelinkdata = data.isGatelink
        let facility: facility = {
          id: data?.id as string,
          name: data?.name as string,
          isGateLink: isGatelinkdata
        }
        this.props.setLocation(
          window.location.pathname + window.location.search
        )
        this.props.setFacility(facility)
        if (isGatelinkdata) {
          this.setState({
            isGateLink: isGatelinkdata
          })
        }

        this.setState({
          isLoading: true
        })
      })
      .catch(err => toast.error(err.response?.data?.error))
    this.validateDriverPhone()
  }

  validateDriverPhone = () => {
    let driverPhone: string = this.getDriverPhone()
    let invalidPhone: boolean =
      driverPhone !== "" ? isInvalidPhone(driverPhone) : false
    let disabledPhone: boolean = driverPhone !== "" ? !invalidPhone : false
    this.setState({
      phone: driverPhone,
      disabledPhone: disabledPhone,
      invalidPhone: invalidPhone
    })
  }

  setCountryCode = (event: any) => {
    let countrycode = event.target.value
    this.setState(
      {
        countryCode: countrycode
      },
      () => {}
    )
  }
  setPhone = (event: any) => {
    let phone = event.target.value
    var reg = /^[0-9]{11}$/
    var checking = reg.test(phone)
    if (!isNumeric(phone) || checking) {
      return
    }

    this.setState({
      phone: phone,
      disabledProceed: phone.length === 0 || this.state.name.length === 0
    })
  }

  setName = (event: any) => {
    let name: string = event.target.value
    if (!isAlphaOrSpace(name) || name.length > 20) {
      return
    }

    this.setState({
      name: name,
      disabledProceed: name.length === 0 || this.state.phone.length === 0
    })
  }

  assetsInfoAPI = async (callback: any) => {
    await http
      .post(
        `${apiEndPoints.submitassetsinfo}`,
        {
          facilityId: this.props.facility.id,
          referenceNumber: this.state.LoadReferenceNumber,
          includeReferenceDetails: true
        },
        {}
      )
      .then(response => {
        let assets = {
          ...this.props.asset,
          id: response.data?.data?.id,
          referenceNumber: this.state.LoadReferenceNumber
        }
        this.props.setAssetInfo(assets)
        this.fetchReferenceDetailsAPI(() => true, assets.id)
      })
      .catch(() => true)
    callback()
  }

  fetchReferenceDetailsAPI = async (callback: any, assetID: any) => {
    await http
      .post(
        `${apiEndPoints.fetchReferenceDetails}`,
        {
          assetID: assetID,
          referenceNumber: this.state.LoadReferenceNumber,
          useWildCard: false
        },
        {}
      )
      .then(
        response => {
          let details = {
            ...this.props.details,
            code: response.status,
            name: response.data?.data?.referenceDetails?.managingCarrier?.name,
            permalink:
              response.data?.data?.referenceDetails?.managingCarrier?.permalink
          }
          this.props.setLoadDetails(details)
        },
        (error: any) => {
          let details = {
            ...this.props.details,
            code: error.response?.data?.code
          }
          this.props.setLoadDetails(details)
        }
      )
      .then(() => this.props.history.push("/carrier-search"))
    callback()
  }

  submitDriverDetails = () => {
    if (!this.state.isGateLink) {
      let invalidPhone: boolean = this.state.phone.length < 10
      let invalidName: boolean = isInvalidName(this.state.name)
      if (invalidPhone || invalidName) {
        this.setState({
          invalidPhone: invalidPhone,
          invalidName: invalidName,
          disabledProceed: true
        })
        return
      }

      http
        .post(
          `${apiEndPoints.facilityVisit}`,
          {
            facility: {
              id: this.props.facility.id
            },
            driver: {
              phone: this.state.countryCode + this.state.phone.trim(),
              name: toTitleCase(this.state.name.trim())
            }
          },
          {}
        )
        .then(response => {
          const { data } = response.data

          const authId = data?.driver?.authentication?.authToken
          const deviceId = data?.driver?.authentication?.deviceId
          const userId = data?.driver?.permalink

          LocalStorage().store("edocAuthId", authId)
          LocalStorage().store("edocDeviceId", deviceId)
          LocalStorage().store("edocUserId", userId)

          document.cookie = `Fp-FourKitesAppType=driver-experience; Domain=fourkites.com`
          document.cookie = `Fp-FourKitesUserId=${userId}; Domain=fourkites.com`
          document.cookie = `Fp-Authorization=Bearer ${authId}; Domain=fourkites.com`
          document.cookie = `Fp-FourKitesDeviceId=${deviceId}; Domain=fourkites.com`

          let visitId: string = data?.visit?.id
          this.props.setDriver({
            name: this.state.name.trim(),
            phone: this.state.phone.trim()
          })

          this.props.setVisit({
            id: visitId,
            visit: data,
            visitPurpose: ""
          })
          this.props.history.push("/reference-details")
          this.props.setPath("")
        })
        .catch(err => {
          toast.error(err.response.data.error)
          this.props.history.push(this.props.location)
        })
    } else {
      this.assetsInfoAPI(() => true)
    }
  }

  setReference = (event: any) => {
    if (event.target.value.trim().length > 0) {
      this.setState({
        disabledProceed: false
      })
    } else {
      this.setState({
        disabledProceed: true
      })
    }
    this.setState({
      LoadReferenceNumber: event.target.value
    })
  }
  handlePaste = (limit: number) => {
    let truncatRefrence = this.state.LoadReferenceNumber.substring(0, limit)
    this.setState({
      LoadReferenceNumber: truncatRefrence
    })
  }

  render() {
    // @ts-ignore: Unreachable code error
    const { t, i18n } = this.props
    return (
      <>
        {this.state.isLoading && (
          <>
            <div className="remove-unwanted-margin-cls container">
              <div
                className={` ${
                  this.state.isGateLink ? "gatelink-ref" : "driver-info"
                }`}
              >
                <div
                  className={` ${
                    this.state.isGateLink
                      ? "gatelink-welcome-text"
                      : "welcome welcome-text"
                  }`}
                >
                  {t("welcome_to")} <br />
                  {this.props.facility.name}!
                </div>
                {!this.state.isGateLink && (
                  <div className="info">{t("basic_details")}</div>
                )}
              </div>
              {!this.state.isGateLink && (
                <>
                  <div
                    className={`driver-input ${
                      this.state.invalidPhone ? "error-label" : ""
                    }`}
                  >
                    <select
                      name="countryCode"
                      className="country-select"
                      value={this.state.countryCode}
                      disabled={this.state.disabledPhone}
                      onChange={event => this.setCountryCode(event)}
                    >
                      <option
                        value="+1"
                        selected={this.state.countryCode == "+1"}
                      >
                        +1
                      </option>
                      <option
                        value="+91"
                        selected={this.state.countryCode == "+91"}
                      >
                        +91
                      </option>
                    </select>
                    <Input
                      className={`padding-left ${
                        this.state.invalidPhone ? "error-label" : ""
                      }`}
                      inputMode="tel"
                      placeholder="123-456-7890"
                      label={t("enter_10_digit_phone_number")}
                      value={this.state.phone}
                      disabled={this.state.disabledPhone}
                      required={true}
                      onClick={() => this.setState({ invalidPhone: false })}
                      onChange={event => this.setPhone(event)}
                      invalid={this.state.invalidPhone}
                      errorLabel={
                        this.state.invalidPhone
                          ? t("phone_number_not_valid")
                          : ""
                      }
                      icon={
                        this.state.invalidPhone ? (
                          <AlertIcon className="elemental-Input-icon--invalid" />
                        ) : (
                          <></>
                        )
                      }
                    />
                  </div>
                  <div
                    className={`driver-input capitalize ${
                      this.state.invalidName ? "error-label" : ""
                    }`}
                  >
                    <Input
                      label={"Full Name"}
                      placeholder={t("eg_john_smith")}
                      value={this.state.name}
                      required={true}
                      onClick={() => this.setState({ invalidName: false })}
                      onChange={event => this.setName(event)}
                      invalid={this.state.invalidName}
                      errorLabel={
                        this.state.invalidName ? t("name_not_valid") : ""
                      }
                      icon={
                        this.state.invalidName ? (
                          <AlertIcon className="elemental-Input-icon--invalid" />
                        ) : (
                          <></>
                        )
                      }
                    />
                  </div>
                </>
              )}
              {this.state.isGateLink && (
                <>
                  <div className={`driver-input driver-gt-input`}>
                    <Input
                      placeholder={t("enter_order_po_bol")}
                      label={t("reference_number")}
                      maxLength={20}
                      value={this.state.LoadReferenceNumber}
                      onChange={event => this.setReference(event)}
                      onPaste={e => this.handlePaste(20)}
                    />
                  </div>
                  <div className="info">
                    <Trans i18nKey="choose_one_text">
                      {" "}
                      <strong>one</strong>
                    </Trans>
                  </div>
                  <div className="gatelink-line" />
                  <div className="info">
                    <b>{t("note")}</b>
                    <br />
                    <br />
                    <Trans i18nKey="process_only_once">
                      {" "}
                      <strong>only once</strong>
                    </Trans>
                    <br />
                    <Trans i18nKey="multiple_order_text">
                      {" "}
                      <strong>any one</strong>
                    </Trans>
                    <br />
                    <br />
                    {t("data_sharing_text")}{" "}
                    <Link
                      href="https://www.fourkites.com/legal/terms-of-use/"
                      underline="always"
                      target="_blank"
                      rel="noopener"
                    >
                      {t("terms_and_conditions")}
                    </Link>
                  </div>
                </>
              )}
              {this.state.mode === "kiosk" && !this.state.isGateLink && (
                <div className="warning-info warning-info-driver">
                  <img className="warning-info-img" src={info} alt="info" />
                  <div className="warning-info-text">
                    <p className="margin-top">{t("session_auto_logout")}</p>
                    <p className="margin-bottom">{t("progress_saved")}</p>
                  </div>
                </div>
              )}
            </div>

            <BottomBar
              disabled={this.state.disabledProceed}
              onClick={() => this.submitDriverDetails()}
              text={t("proceed")}
              endIcon={<KeyboardArrowRightIcon />}
            />
          </>
        )}
      </>
    )
  }
}

export default withTranslation()(withRouter(connector(DriverForm)))
